import { Shark } from "shark-mvc";
// import moment from "moment";

import NousCoreModel from "./NousCoreModel";
import UserPermission from "./UserPermission";

class Activity extends NousCoreModel {
	static STATUS_ARCHIVED = 3;
	static STATUS_CLOSE = 2;
	static STATUS_OPEN = 1;

	anyoneOpenTaskCount = 0;
	assignedOpenTaskCount = 0;
	description = "";
	name = "";
	projectGuid = "";
	tags = [];
	totalOpenTaskCount = 0;

	__addTaskPermission = false;
	__allTaskPermissions = false;
	__allTaskPermissionsIndeterminate = false;
	__assignTaskPermission = false;
	__cancelTaskPermission = false;
	__closed = false;
	__closeTaskPermission = false;
	__editTaskPermission = false;
	__taskList = [];
	__userAccessGuidPermissions = [];
	__userAccessPermissions = new Map();
	__userIsOwner = false;

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	changePermission (permission, value, preventAllPermissionCheck = false) {
		const { userAssigningPermissions } = Shark.get();

		if (this.__userAccessPermissions.has(userAssigningPermissions.guid)) {
			const userPermission = this.__userAccessPermissions.get(userAssigningPermissions.guid);

			if (value === true) {
				userPermission.settings.permissions.push(permission);
			}
			else {
				userPermission.settings.permissions = userPermission.settings.permissions.filter(item => item !== permission);
			}
			//this.__userAccessPermissions.get(userAssigningPermissions.guid).status = UserPermission.STATUS_ACTIVE;
		}
		else {
			// const newUserPermission = new UserPermission({
			// 	referenceGuid: this.guid,
			// 	settings: {
			// 		permissions: ["addActivity"],
			// 	},
			// 	status: 1,
			// 	type: "project",
			// 	userGuid: userAssigningPermissions.guid,
			// });
			// this.__userAccessPermissions.set(userAssigningPermissions.guid, newUserPermission);
		}

		if (!preventAllPermissionCheck) {
			this.checkAllTaskPermissions();
		}
	}

	checkAllTaskPermissions () {
		this.__allTaskPermissions = (this.__addTaskPermission && this.__closeTaskPermission && this.__editTaskPermission && this.__cancelTaskPermission && this.__assignTaskPermission);
		this.__allTaskPermissionsIndeterminate = !(
			this.__addTaskPermission === this.__closeTaskPermission &&
			this.__closeTaskPermission === this.__editTaskPermission &&
			this.__editTaskPermission === this.__cancelTaskPermission &&
			this.__cancelTaskPermission === this.__assignTaskPermission
		);
		Shark.render();
	}

	checkPermissionForUser () {
		const { userAssigningPermissions } = Shark.get();

		if (userAssigningPermissions && this.__userAccessPermissions.has(userAssigningPermissions.guid)) {
			const userPermission = this.__userAccessPermissions.get(userAssigningPermissions.guid);

			this.__addTaskPermission = userPermission.settings.permissions.includes("addTask");
			this.__assignTaskPermission = userPermission.settings.permissions.includes("assignTask");
			this.__cancelTaskPermission = userPermission.settings.permissions.includes("cancelTask");
			this.__closeTaskPermission = userPermission.settings.permissions.includes("closeTask");
			this.__editTaskPermission = userPermission.settings.permissions.includes("editTask");

			this.__addTaskPermissionInherited = userPermission.__inherited;
			this.__assignTaskPermissionInherited = userPermission.__inherited;
			this.__cancelTaskPermissionInherited = userPermission.__inherited;
			this.__closeTaskPermissionInherited = userPermission.__inherited;
			this.__editTaskPermissionInherited = userPermission.__inherited;

			this.checkAllTaskPermissions();
		}
	}

	export () {
		let exportData = super.export();

		exportData.tags = this.exportArrayField("tags");
		
		return exportData;
	}

	import (data) {
		super.import(data);

		this.importNumberField("anyoneOpenTaskCount", data.anyoneOpenTaskCount);
		this.importNumberField("assignedOpenTaskCount", data.assignedOpenTaskCount);
		this.importNumberField("totalOpenTaskCount", data.totalOpenTaskCount);

		this.__userIsOwner = Shark.$store.loggedUser.guid === this.createdByGuid;

		this.parseDescription();
		this.parseStatus();
	}

	
	on__addTaskPermissionChanged (event, data) {
		this.changePermission("addTask", data.newValue);
	}

	on__allTaskPermissionsChanged () {
		this.changePermission("addTask", this.__allTaskPermissions, true);
		this.changePermission("assignTask", this.__allTaskPermissions, true);
		this.changePermission("cancelTask", this.__allTaskPermissions, true);
		this.changePermission("closeTask", this.__allTaskPermissions, true);
		this.changePermission("editTask", this.__allTaskPermissions, true);

		this.checkAllTaskPermissions();
		this.checkPermissionForUser();
	}

	on__assignTaskPermissionChanged (event, data) {
		this.changePermission("assignTask", data.newValue);
	}

	on__cancelTaskPermissionChanged (event, data) {
		this.changePermission("cancelTask", data.newValue);
	}

	on__closeTaskPermissionChanged (event, data) {
		this.changePermission("closeTask", data.newValue);
	}

	on__editTaskPermissionChanged (event, data) {
		this.changePermission("editTask", data.newValue);
	}

	on__userAccessPermissionsChanged () {
		this.__userAccessGuidPermissions = Array.from(this.__userAccessPermissions.values()).filter(item => item.status === 1).map(item => item.userGuid);
		this.checkPermissionForUser();
		console.log(this);
	}

	on__userAccessGuidPermissionsChanged (event, data) {
		console.log(data, this);

		if (data.newValue.length > data.oldValue.length) {
			const userGuid = data.newValue[data.newValue.length - 1];

			if (this.__userAccessPermissions.has(userGuid)) {
				this.__userAccessPermissions.get(userGuid).status = UserPermission.STATUS_ACTIVE;
			}
			else {
				const newUserPermission = new UserPermission({
					referenceGuid: this.guid,
					settings: {
						permissions: ["access"],
					},
					status: 1,
					type: "activity",
					userGuid,
				});
	
				this.__userAccessPermissions.set(userGuid, newUserPermission);
			}
		}
		else {
			const userGuids = data.oldValue.filter(item => !data.newValue.includes(item));

			if (userGuids.length === 1) {
				if (this.__userAccessPermissions.get(userGuids[0]).guid === "") {
					this.__userAccessPermissions.delete(userGuids[0]);
				}
				else {
					this.__userAccessPermissions.get(userGuids[0]).status = UserPermission.STATUS_INACTIVE;
				}
			}
		}

		console.log(this);
	}

	onDescriptionChanged () {
		this.parseDescription();
	}

	parseDescription () {
		this.__descriptionAbstract = this.description.length > 60 ? this.description.slice(0, 80) + "..." : this.description;
	}

	parseStatus () {
		this.__editable = [Activity.STATUS_OPEN].includes(this.status);

		switch (this.status) {
			case 1:
				this.__statusCSSClass = "";
				break;
			case 2:
				this.__statusCSSClass = "bg-danger text-white";
				break;
		}

		// Dave: questa roba è da fare col "renderer" come abbiamo iniziato su TimeCorder

		if (this.assignedOpenTaskCount > 0) {
			this.__statusCSSClass += "bg-info bg-opacity-10";
		}
	}

	validate () {
		const errors = [];
		this.__errors = {};

		if (this.name.trim() === "") {
			errors.push("Devi inserire il nome dell'Attività");
			this.__errors.contacts = true;
		}

		this.__isValid = errors.length === 0;

		return errors;
	}
}

Shark.registerModel("Activity", Activity);

export default Activity;
